<ion-app>
  <div class="be-sticky-header" *ngIf="!hideHeader">
    <app-homeheader></app-homeheader>
  </div>
  
  <ion-router-outlet main [class.no-header]="hideHeader">
  </ion-router-outlet>
  
  <!-- Hero transition overlay for shared element animations -->
  <app-hero-transition-overlay></app-hero-transition-overlay>
</ion-app>
